import React from 'react';
import { Layout, Typography, Space, Divider } from 'antd';

const { Footer } = Layout;
const { Text, Link } = Typography;

const AppFooter: React.FC = () => {
  return (
    <Footer 
      style={{ 
        textAlign: 'center', 
        padding: '24px 32px',
        background: '#ffffff',
        borderTop: '1px solid #e5e7eb',
        marginTop: 'auto'
      }}
    >
      <Space 
        direction="vertical" 
        size="small" 
        style={{ width: '100%' }}
      >
        <Space 
          split={<Divider type="vertical" style={{ borderColor: '#d1d5db' }} />}
          size="large"
          wrap
          style={{ justifyContent: 'center' }}
        >
          <Link 
            href="#" 
            style={{ 
              color: '#6b7280', 
              fontSize: '14px',
              textDecoration: 'none',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#374151';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#6b7280';
            }}
          >
            Politique de confidentialité
          </Link>
          <Link 
            href="#" 
            style={{ 
              color: '#6b7280', 
              fontSize: '14px',
              textDecoration: 'none',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#374151';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#6b7280';
            }}
          >
            Conditions d'utilisation
          </Link>
          <Link 
            href="#" 
            style={{ 
              color: '#6b7280', 
              fontSize: '14px',
              textDecoration: 'none',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#374151';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#6b7280';
            }}
          >
            Support
          </Link>
          <Link 
            href="#" 
            style={{ 
              color: '#6b7280', 
              fontSize: '14px',
              textDecoration: 'none',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#374151';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#6b7280';
            }}
          >
            Documentation
          </Link>
        </Space>
        
        <Text style={{ 
          color: '#6b7280', 
          fontSize: '14px',
          fontWeight: '400'
        }}>
          © {new Date().getFullYear()} Tableau de bord d'administration AVEC. Tous droits réservés.
        </Text>
        
        {/* <Text style={{ 
          color: '#9ca3af', 
          fontSize: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '4px'
        }}>
          Fait avec <HeartFilled style={{ color: '#dc2626', fontSize: '12px' }} /> pour les communautés AVEC
        </Text> */}
      </Space>
    </Footer>
  );
};

export default AppFooter;